var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislikeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4063 3.67351L10.4063 10.4468C10.4063 10.7135 10.3263 10.9735 10.1796 11.1935L8.35958 13.9002C8.07292 14.3335 7.35958 14.6402 6.75292 14.4135C6.09958 14.1935 5.66625 13.4602 5.80625 12.8068L6.15292 10.6268C6.17958 10.4268 6.12625 10.2468 6.01292 10.1068C5.89958 9.98018 5.73292 9.90018 5.55292 9.90018L2.81292 9.90018C2.28625 9.90018 1.83292 9.68685 1.56625 9.31351C1.31292 8.95351 1.26625 8.48685 1.43292 8.01351L3.07292 3.02018C3.27958 2.19351 4.17958 1.52018 5.07292 1.52018L7.67292 1.52018C8.11958 1.52018 8.74625 1.67351 9.03292 1.96018L9.88625 2.62018C10.2129 2.86685 10.4063 3.26018 10.4063 3.67351Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.528 11.7466L13.2146 11.7466C14.248 11.7466 14.668 11.3466 14.668 10.3599L14.668 3.65325C14.668 2.66658 14.248 2.26658 13.2146 2.26658L12.528 2.26658C11.4946 2.26658 11.0746 2.66658 11.0746 3.65325L11.0746 10.3599C11.0746 11.3466 11.4946 11.7466 12.528 11.7466Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeFilled);
export default __webpack_public_path__ + "static/media/dislike_filled.f9d09a60b89a65ddef4314c4692513c3.svg";
export { ForwardRef as ReactComponent };